"use client";

import { useIndustries, type Industry } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface IndustryComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
}

export const IndustryCombobox = ({ initialValue, onChange, onClear, disabled }: IndustryComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { industries, isLoading } = useIndustries({ keyword, enabled: !disabled, page: 1, limit: 5 });

  const options: ComboboxOption[] = industries.map((industry: Industry) => ({
    value: industry.id,
    label: industry.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih industri"
      searchPlaceholder="Cari industri..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
